import {ImageLoadPromise} from '../promises/ImageLoadPromise';
import {AbstractTransition} from './AbstractTransition';
import {DPlexArguments} from '../DPlexArguments';

type ScrollPosition={
    element: HTMLElement,
    left?: number,
    top?: number
}

export class OverlayTransition extends AbstractTransition {

    protected inner;

    constructor(protected args:DPlexArguments) {
        let originalLeave=args.leave;
        super(args);
        args.leave=this.freeze(args.leave);
        if (originalLeave.hasClass('modal')) this.modalLeave=true;
        this.inner=originalLeave;
        this.initScrollPosition();
        this.waitForImages();
    }

    protected getMaxZIndex(root: JQuery<HTMLElement>): number {
        let max = -Infinity;

        const elements = root.add(root.find('*'));

        elements.each((_, el) => {
            const value = parseInt(getComputedStyle(el).zIndex, 10);
            if (!isNaN(value) && value > max) {
                max = value;
            }
        });

        return max === -Infinity ? 0 : max;
    }

    protected async waitForImages() {
        let imgs=this.getImagesInEnteringViewport();
        if (imgs) {
            await new ImageLoadPromise(imgs);
        }
    }

    protected getImagesInEnteringViewport(): JQuery<HTMLImageElement>|void {
        if (!this.args.enter) return;

        let viewportHeight = window.innerHeight;
        let viewportWidth = window.innerWidth;
        let images = this.args.enter.find('img');

        return images.filter((_index: number, img: HTMLImageElement) => {
            let rect = img.getBoundingClientRect();
            let verticallyVisible = rect.bottom > 0 && rect.top < viewportHeight;
            let horizontallyVisible = rect.right > 0 && rect.left < viewportWidth;
            return verticallyVisible && horizontallyVisible;
        });
    }

    protected freeze(element:JQuery<HTMLElement>) {
        let left=element.offset()?.left??0;
        let top=element.offset()?.top??0;
        let width=element.width()??0;
        let height=element.height()??0;
        let rect=element[0].getBoundingClientRect();

        let wrapper=$('<div></div>');
        wrapper.insertBefore(element);

        let scrolls=this.saveScrollPositions(element);
        wrapper.append(element);
        this.restoreScrollPositions(scrolls);

        wrapper.addClass('overlay-transition-wrapper');
        wrapper.css('position','fixed');
        wrapper.css('z-index',0);
        wrapper.css('left',left);
        wrapper.css('top',top);
        wrapper.css('width',width);
        wrapper.css('height',height);
        element.css('position','absolute');
        element.css('width','100%');
        element.css('height','100%');
        element.css('top',rect.top-top);

        return wrapper;
    }

    protected unfreeze(element:JQuery<HTMLElement>) {
        let outer=element.parent();
        element.insertBefore(outer);
        outer.remove();

        element.css('position','');
        element.css('width','');
        element.css('height','');
        element.css('top','');
    }

    private isFirefoxAndroid() {
        return /Android.+Firefox\//.test(navigator.userAgent);
    }

    private iOS() {
        return ['iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'].includes(navigator.platform)
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document); // iPad on iOS 13 detection
    }

    protected initScrollPosition() {
        if (this.isFirefoxAndroid()) {
            document.documentElement.style.display="none";
            document.documentElement.offsetHeight;
            document.documentElement.style.display="";
        }

        document.documentElement.scrollTop=this.args.metadata.enter.scrollY;
        //Delay animaton on buggy iOS for 100ms after scrolling.
        //Animation and scrolling cannot happen at the same time.
        this.playDelay=this.iOS()?100:0;
    }

    private saveScrollPositions(leave:JQuery<HTMLElement>) {
        let scrolls:ScrollPosition[]=[];
        for (let e of leave.find('*')) {
            let scroll:ScrollPosition={element:e};
            if (e.scrollLeft>0) scroll.left=e.scrollLeft;
            if (e.scrollTop>0) scroll.top=e.scrollTop;
            if (scroll.left || scroll.top) scrolls.push(scroll);
        };
        return scrolls;
    }

    private restoreScrollPositions(scrolls:ScrollPosition[]) {
        for (let scroll of scrolls) {
            if (scroll.left) scroll.element.scrollLeft=scroll.left;
            if (scroll.top) scroll.element.scrollTop=scroll.top;
        }
    }

    public before() {
        super.before();
        if (this.modalLeave) this.args.enter.unwrap();
    }

    public after() {
        super.after();
        if (!this.modalEnter || this.modalLeave) {
            this.inner.trigger('leave');
            this.args.leave.remove();
        } else {
            this.inner.removeClass('leave leaving');
            $('.loading').removeClass('loading');
        }
    }

}

export {};